import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper";

const Dependence_level = () => {
    const initialFormState = {
        dependence_level_id: 0,
        tobacco_product_type_id_fk:'',
        min_score: '',
        max_score: '',
        icon: '',
        level_name: '',
        ease_level: '',
        description: ''
    };

    const [formData, setFormData] = useState(initialFormState);
    const [validated, setValidated] = useState(false);
    const [tobaccoProductTypeList, setTobaccoProductTypeList] = useState([]);
    const [dependenceLevelList, setDependenceLevelList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Actions',
                cell: ({ row }) => (
                    <>
                        <i
                            className="ri-file-edit-fill text-primary cursor-pointer me-2"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                            style={{ fontSize: "18px" }}
                        />
                    </>
                ),
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                header: 'Tobacco Product Type Name',
                accessorKey: 'tobacco_product_type_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Level Name',
                accessorKey: 'level_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Min Score',
                accessorKey: 'min_score',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Max Score',
                accessorKey: 'max_score',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Icon',
                accessorKey: 'icon',
                enableColumnFilter: false,
                enableSorting: false,
                label_condition : 'icon'
            },
            {
                header: 'Ease Level',
                accessorKey: 'ease_level',
                enableColumnFilter: false,
                enableSorting: true,
            }
        ],
        []
    );

    const handleEdit = (row) => {
        setFormData({
            dependence_level_id: row.dependence_level_id,
            tobacco_product_type_id_fk : row.tobacco_product_type_id_fk,
            min_score: row.min_score,
            max_score: row.max_score,
            icon: row.icon,
            level_name: row.level_name,
            ease_level: row.ease_level,
            description: row.description
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            showAlert('error', 'Oops...', 'Please fill in all required fields.');
            setValidated(true);
        } else {
            try {
                setValidated(false);
                const response = await post("/masters/dependence_level", formData);
                if (response.status === 200) {
                    showAlert('success', 'Saved', response.message);
                    fetchData();
                    setFormData(initialFormState);
                } else {
                    showAlert('error', response.status, response.message);
                }
            } catch (err) {
                showAlert('error', 'Unexpected Error', err.message);
            }
        }
    };

    const handleReset = () => {
        setFormData(initialFormState);
        setValidated(false);
    };

    const fetchData = async () => {
        try {
            const response = await post("/masters/dependence_level_list");
            if (response.status === 200) {
                setDependenceLevelList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    const fetchProductTypeData = async () => {
        try {
            const response = await post("/masters/tobacco_product_type_list");
            if (response.status === 200) {
                setTobaccoProductTypeList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
        fetchProductTypeData();
    }, []);

    return (
        <div className="row">
            <div className="col-lg-3">
                <div className="card">
                    <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
                        <div className="card-header">
                            <h5 className="card-title mb-0">DEPENDENCE LEVEL</h5>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <label>Tobacco Product Type</label>
                                    <select
                                        name="tobacco_product_type_id_fk"
                                        className="form-control radius-4 form-select"
                                        value={formData.tobacco_product_type_id_fk}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select</option>
                                        {tobaccoProductTypeList.map((tobacco_product_type) => (
                                            <option key={tobacco_product_type.tobacco_product_type_id} value={tobacco_product_type.tobacco_product_type_id}>
                                            {tobacco_product_type.tobacco_product_type_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-12">
                                    <label>Level Name</label>
                                    <select className="form-control"
                                        id="level_name"
                                        name="level_name"
                                        value={formData.level_name}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value={"Very low"}>Very low</option>
                                        <option value={"Medium"}>Medium</option>
                                        <option value={"High "}>High </option>
                                        <option value={"Very high"}>Very high</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label>Min Score</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="min_score"
                                        name="min_score"
                                        value={formData.min_score}
                                        onChange={handleChange}
                                        required
                                        placeholder="Min Score"
                                        min="0"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Max Score</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="max_score"
                                        name="max_score"
                                        value={formData.max_score}
                                        onChange={handleChange}
                                        required
                                        placeholder="Max Score"
                                        min="0"
                                    />
                                </div>

                                <div className="col-md-12">
                                    <label>Icon</label>
                                    <select className="form-control"
                                        id="icon"
                                        name="icon"
                                        value={formData.icon}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value={"🟢"}>🟢 Very low</option>
                                        <option value={"🟠"}>🟠 Medium</option>
                                        <option value={"🔴"}>🔴 High</option>
                                        <option value={"🚨"}>🚨 Very High</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <label>Ease Level</label>
                                    <select className="form-control"
                                        id="ease_level"
                                        name="ease_level"
                                        value={formData.ease_level}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value={"High"}>High</option>
                                        <option value={"Good"}>Good</option>
                                        <option value={"Moderate"}>Moderate</option>
                                        <option value={"Harder"}>Harder</option>
                                        <option value={"Difficult"}>Difficult</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <label>Description</label>
                                    <textarea
                                        className="form-control"
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder="Description"
                                        rows={3}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-primary btn-sm" style={{ float: "right" }}>SAVE</button>
                                    <button type="button" onClick={handleReset} className="btn btn-sm btn-secondary">Clear</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-9">
                <div className="card basic-data-table">
                    <div className="card-header">
                        <h5 className="card-title mb-0">Dependence Level List</h5>
                    </div>
                    <div className="card-body">
                        <Customtable
                            table_title="Dependence Level List"
                            columns={columns}
                            data={dependenceLevelList}
                            isGlobalFilter={true}
                            isPagination={true}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            isExportButton={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dependence_level;
